module.exports = __webpack_public_path__ + "images/118_1024.jpg";